export default "__VITE_ASSET__BxMfeNhG__"